import { useQuery } from "@apollo/client";
import { EntityTypeFilterValue } from "../../../../legacy/types/companyFilter";
import { PRODUCT_COMPANY_COUNT_QUERY } from "../queries/productInstallQuery";
import { COMPANY_SEARCH_CLIENT } from "../../../../utils/consts";

export const useProductInstallQuery = (
  productId: number,
  localizeInstalls: boolean,
  entityTypeFilterValue: EntityTypeFilterValue
) => {
  const { isDp, isDu, isGhq, isGp, isGu } = entityTypeFilterValue;

  const { data, loading } = useQuery(PRODUCT_COMPANY_COUNT_QUERY, {
    variables: {
      productId,
      localizeInstalls,
      isDp,
      isDu,
      isGhq,
      isGp,
      isGu,
    },
    skip: productId === 0,
    context: {
      clientName: COMPANY_SEARCH_CLIENT,
    },
  });

  return [data?.opportunityGeneratorSearch || { data: [], count: 0 }, loading];
};
